export interface ComicCategory {
  slug: string;
  name: string;
  icon: string;
  description: string;
}

export interface ComicChapter {
  id: string;
  title: string;
  number: number;
  updatedAt: string;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  coverImage: string;
  description: string;
  longDescription: string;
  categories: string[];
  status: '连载中' | '已完结';
  rating: number;
  views: number;
  favorites: number;
  chapters: ComicChapter[];
  tags: string[];
  updatedAt: string;
  createdAt: string;
}

export const CATEGORIES: ComicCategory[] = [
  { slug: 'all', name: '全部', icon: 'ri-apps-line', description: '浏览全部韩漫作品' },
  { slug: 'romance', name: '恋爱', icon: 'ri-heart-line', description: '甜蜜浪漫的恋爱故事' },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line', description: '奇幻世界的冒险旅程' },
  { slug: 'action', name: '动作', icon: 'ri-sword-line', description: '热血沸腾的动作场面' },
  { slug: 'suspense', name: '悬疑', icon: 'ri-search-eye-line', description: '扣人心弦的悬疑推理' },
  { slug: 'comedy', name: '搞笑', icon: 'ri-emotion-laugh-line', description: '轻松幽默的搞笑日常' },
  { slug: 'healing', name: '治愈', icon: 'ri-heart-pulse-line', description: '温暖心灵的治愈故事' },
  { slug: 'drama', name: '剧情', icon: 'ri-film-line', description: '引人入胜的剧情佳作' },
  { slug: 'horror', name: '恐怖', icon: 'ri-ghost-line', description: '惊悚刺激的恐怖漫画' },
  { slug: 'bl', name: 'BL', icon: 'ri-user-heart-line', description: '唯美动人的BL作品' },
];

export const COMICS: Comic[] = [
  {
    id: 'comic-1',
    title: '秘密花园',
    author: '朴智慧',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20style%20illustration%20of%20a%20young%20couple%20in%20a%20secret%20garden%20full%20of%20flowers%2C%20soft%20romantic%20atmosphere%2C%20warm%20sunlight%20filtering%20through%20leaves%2C%20gentle%20pastel%20colors%2C%20anime%20art%20style%2C%20clean%20simple%20background%20with%20bokeh%20effect%2C%20vertical%20composition&width=800&height=1100&seq=comic-cover-01&orientation=portrait',
    description: '平凡的女高中生偶然发现了学校后山的秘密花园，在那里遇到了神秘的美少年。一段跨越身份差异的校园爱情故事就此展开。',
    longDescription: '金多海是一名普通的高中二年级学生，性格内向的她总是独来独往。一天放学后，她无意中走进了学校后山的一片废弃花园——那里开满了从未见过的奇异花朵。更令她惊讶的是，花园里住着一位名叫尹星河的神秘少年。他声称自己是在这里等待一个人，已经等了很久很久……\n\n随着两人逐渐熟络，多海发现星河身上隐藏着惊人的秘密——他其实并非普通人类，而是一个被诅咒的灵魂，被困在这片花园中已经百年。每当月圆之夜，他才能短暂地以实体形态出现。两个来自不同世界的灵魂，在秘密花园中展开了一段既甜蜜又忧伤的奇妙恋情。',
    categories: ['all', 'romance', 'fantasy'],
    status: '连载中',
    rating: 4.8,
    views: 1520000,
    favorites: 89000,
    chapters: [
      { id: 'ch-1-1', title: '第1话：不速之客', number: 1, updatedAt: '2026-08-01' },
      { id: 'ch-1-2', title: '第2话：花园的秘密', number: 2, updatedAt: '2026-08-02' },
      { id: 'ch-1-3', title: '第3话：月圆之夜', number: 3, updatedAt: '2026-08-03' },
      { id: 'ch-1-4', title: '第4话：无法触碰的手', number: 4, updatedAt: '2026-08-04' },
      { id: 'ch-1-5', title: '第5话：百年前的约定', number: 5, updatedAt: '2026-08-04' },
    ],
    tags: ['校园', '奇幻', '纯爱', '催泪'],
    updatedAt: '2026-08-04',
    createdAt: '2026-06-15',
  },
  {
    id: 'comic-2',
    title: '暗夜追踪者',
    author: '金泰勋',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20Korean%20manhwa%20style%20illustration%20of%20a%20mysterious%20detective%20in%20a%20black%20trench%20coat%20standing%20in%20a%20rainy%20neon-lit%20alleyway%20at%20night%2C%20noir%20atmosphere%2C%20dramatic%20lighting%2C%20suspenseful%20mood%2C%20clean%20simple%20composition%2C%20vertical%20portrait%20orientation&width=800&height=1100&seq=comic-cover-02&orientation=portrait',
    description: '首尔江南区连续发生离奇失踪案，前刑警出身的私家侦探奉命追查真相。越深入调查，他越发现自己似乎也成了猎物的目标。',
    longDescription: '李明宇曾是首尔警署最年轻的刑警队长，因一次任务失误被迫离职。如今他靠着私家侦探的身份谋生，日子过得平淡无奇，直到江南区富豪圈的连续失踪案找上了他。\n\n五个富家千金在一个月内先后人间蒸发，现场没有任何挣扎痕迹，只有一面镜子被整齐地摆放成特定的角度。明宇发现每起案件都指向一个神秘的地下组织——"镜面会"。而这个组织似乎早在二十年前就已经存在，与他父亲的死亡有着千丝万缕的联系。\n\n随着调查深入，危险一步步逼近，明宇发现自己身边的每个人都可能是敌人，而真相远比想象中更加黑暗……',
    categories: ['all', 'suspense', 'action'],
    status: '连载中',
    rating: 4.7,
    views: 980000,
    favorites: 62000,
    chapters: [
      { id: 'ch-2-1', title: '第1话：最后一件委托', number: 1, updatedAt: '2026-07-28' },
      { id: 'ch-2-2', title: '第2话：失踪的千金', number: 2, updatedAt: '2026-07-29' },
      { id: 'ch-2-3', title: '第3话：镜中人', number: 3, updatedAt: '2026-07-30' },
      { id: 'ch-2-4', title: '第4话：地下暗流', number: 4, updatedAt: '2026-08-01' },
    ],
    tags: ['悬疑', '推理', '都市', '暗黑'],
    updatedAt: '2026-08-01',
    createdAt: '2026-05-20',
  },
  {
    id: 'comic-3',
    title: '剑与魔法学院',
    author: '崔允儿',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20fantasy%20Korean%20manhwa%20style%20illustration%20of%20a%20young%20female%20mage%20student%20holding%20a%20glowing%20sword%20in%20a%20magical%20academy%20castle%20setting%2C%20sparkling%20magic%20effects%2C%20vibrant%20colors%2C%20adventure%20theme%2C%20anime%20art%20style%2C%20vertical%20portrait%20with%20clean%20simple%20background&width=800&height=1100&seq=comic-cover-03&orientation=portrait',
    description: '拥有双重天赋的少女进入大陆最顶尖的魔法学院，在这里她将面对学业挑战、友情羁绊，以及一个足以毁灭世界的巨大阴谋。',
    longDescription: '在艾瑟兰大陆，每个人出生时只能觉醒一种魔法天赋——要么是元素魔法，要么是剑术。但有一个人例外。\n\n卡莲·罗斯维尔，一个来自偏远村庄的平民少女，在入学测试中同时展现了水火双元素亲和力与A级剑术天赋。她因此被破格录取进入只有贵族才能就读的格里芬皇家魔法学院，成为了学院历史上第一位"双重天赋"持有者。\n\n然而学院并非天堂。贵族学生的排挤、严苛的考核、以及深夜图书馆中传来的诡异声响，都预示着更大的风暴即将来临。当卡莲无意中发现了学院地下密室中的上古封印，她意识到自己来到这所学院绝非偶然……',
    categories: ['all', 'fantasy', 'action'],
    status: '连载中',
    rating: 4.9,
    views: 2100000,
    favorites: 115000,
    chapters: [
      { id: 'ch-3-1', title: '第1话：双重觉醒', number: 1, updatedAt: '2026-08-03' },
      { id: 'ch-3-2', title: '第2话：入学测试', number: 2, updatedAt: '2026-08-03' },
      { id: 'ch-3-3', title: '第3话：贵族与平民', number: 3, updatedAt: '2026-08-04' },
      { id: 'ch-3-4', title: '第4话：地下密室', number: 4, updatedAt: '2026-08-05' },
    ],
    tags: ['魔法', '校园', '冒险', '女性向'],
    updatedAt: '2026-08-05',
    createdAt: '2026-06-01',
  },
  {
    id: 'comic-4',
    title: '邻家姐姐是明星',
    author: '李恩在',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20cute%20Korean%20manhwa%20style%20illustration%20of%20a%20beautiful%20female%20idol%20next%20door%20waving%20at%20a%20shy%20young%20man%2C%20bright%20sunny%20morning%20scene%2C%20modern%20apartment%20setting%2C%20cheerful%20romantic%20comedy%20vibe%2C%20warm%20pastel%20colors%2C%20clean%20composition%2C%20vertical%20orientation&width=800&height=1100&seq=comic-cover-04&orientation=portrait',
    description: '平凡的大学生金秀赫某天发现，搬到自己隔壁的竟然是国民偶像姜娜英！一段充满笑料与心跳的"邻居恋爱喜剧"就此上演。',
    longDescription: '金秀赫的人生哲学很简单：不引人注目，平安度过大学四年。然而这个朴素的愿望在他新邻居搬来的那天彻底粉碎了。\n\n新邻居不是别人，正是韩国顶流女团"STARLIGHT"的成员姜娜英——一个拥有千万粉丝的国民偶像。更离谱的是，娜英似乎完全不在意被认出，每天素颜出门、穿着拖鞋倒垃圾，还经常敲秀赫的门借酱油。\n\n最让秀赫崩溃的是，娜英好像把他当成了唯一可以自由做自己的朋友，而这段奇妙的邻里关系很快被狗仔盯上。当绯闻照片登上热搜，秀赫被迫卷入了一场他从未想象过的娱乐圈风暴中……',
    categories: ['all', 'romance', 'comedy'],
    status: '连载中',
    rating: 4.6,
    views: 1800000,
    favorites: 95000,
    chapters: [
      { id: 'ch-4-1', title: '第1话：新邻居', number: 1, updatedAt: '2026-08-02' },
      { id: 'ch-4-2', title: '第2话：第一个早晨', number: 2, updatedAt: '2026-08-02' },
      { id: 'ch-4-3', title: '第3话：绯闻风暴', number: 3, updatedAt: '2026-08-03' },
      { id: 'ch-4-4', title: '第4话：秘密约会', number: 4, updatedAt: '2026-08-04' },
      { id: 'ch-4-5', title: '第5话：舞台之上', number: 5, updatedAt: '2026-08-05' },
    ],
    tags: ['娱乐圈', '恋爱喜剧', '都市', '甜宠'],
    updatedAt: '2026-08-05',
    createdAt: '2026-06-10',
  },
  {
    id: 'comic-5',
    title: '千年血族',
    author: '张贤宇',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20gothic%20Korean%20manhwa%20style%20illustration%20of%20a%20handsome%20male%20vampire%20with%20crimson%20eyes%20in%20a%20dark%20castle%20room%2C%20moonlight%20streaming%20through%20stained%20glass%20windows%2C%20dark%20romantic%20atmosphere%2C%20elegant%20Victorian-inspired%20clothing%2C%20vertical%20portrait%20with%20dramatic%20lighting&width=800&height=1100&seq=comic-cover-05&orientation=portrait',
    description: '活了千年的吸血鬼之王在现代首尔醒来，他必须适应这个全新的世界，同时与追杀了他几个世纪的宿敌展开最后的对决。',
    longDescription: '卡西恩·德拉克，血族十三氏族的至高之王，在千年前的那场圣战中身负重伤陷入沉睡。当他再次睁开眼睛时，周围的一切都变了——高楼林立、霓虹闪烁，他正躺在一家二手书店的地下室里，而唤醒他的竟然是一个爱看吸血鬼小说的女大学生。\n\n在这个被现代科技统治的世界里，卡西恩的力量因为千年的沉睡而大幅衰减，而当年将他封印的猎魔人后裔们已经察觉到了他的苏醒。为了保护唤醒自己的女孩，也为了夺回属于血族的荣耀，卡西恩不得不在这个陌生的时代重新崛起。\n\n但他没想到的是，最大的敌人并非猎魔人后裔，而是自己体内开始觉醒的、更加古老而危险的某种力量……',
    categories: ['all', 'fantasy', 'action', 'romance'],
    status: '连载中',
    rating: 4.8,
    views: 1650000,
    favorites: 88000,
    chapters: [
      { id: 'ch-5-1', title: '第1话：千年后的苏醒', number: 1, updatedAt: '2026-07-31' },
      { id: 'ch-5-2', title: '第2话：新世纪', number: 2, updatedAt: '2026-08-01' },
      { id: 'ch-5-3', title: '第3话：猎魔人的继承者', number: 3, updatedAt: '2026-08-02' },
    ],
    tags: ['吸血鬼', '都市奇幻', '战斗', '暗黑浪漫'],
    updatedAt: '2026-08-02',
    createdAt: '2026-05-25',
  },
  {
    id: 'comic-6',
    title: '治愈咖啡馆',
    author: '姜美莱',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20warm%20Korean%20manhwa%20style%20illustration%20of%20a%20cozy%20small%20cafe%20with%20a%20gentle%20barista%20girl%20making%20coffee%2C%20soft%20morning%20light%2C%20wooden%20interior%2C%20plants%20and%20books%2C%20healing%20atmosphere%2C%20pastel%20warm%20tones%2C%20clean%20simple%20composition%2C%20vertical%20portrait&width=800&height=1100&seq=comic-cover-06&orientation=portrait',
    description: '在繁华都市的一角，有一家小小的咖啡馆。每个来到这里的人，都会带着各自的烦恼离开，留下一个温暖的故事。',
    longDescription: '首尔弘大的小巷深处，有一家名为"早安咖啡"的小店。店长是一位二十出头的女孩，名叫韩素恩。她没有魔法，也不会通灵，但她泡的每一杯咖啡都似乎有着不可思议的力量——让喝的人不自觉地敞开心扉。\n\n失恋的白领、迷茫的学生、孤独的老人、争吵的情侣……各色各样的人带着不同的烦恼走进这家店，在与素恩的简单交谈和一杯温暖的咖啡后，似乎都能找到继续前行的力量。\n\n这并非什么超能力，而是素恩用自己的方式——认真倾听和一杯用心泡制的咖啡——温暖着每一个疲惫的灵魂。而素恩自己，也在治愈他人的过程中，慢慢愈合着自己内心深处的伤痛。',
    categories: ['all', 'healing', 'drama'],
    status: '已完结',
    rating: 4.9,
    views: 1350000,
    favorites: 102000,
    chapters: [
      { id: 'ch-6-1', title: '第1话：早安咖啡', number: 1, updatedAt: '2026-06-01' },
      { id: 'ch-6-2', title: '第2话：失恋的客人', number: 2, updatedAt: '2026-06-08' },
      { id: 'ch-6-3', title: '第3话：奶奶的回忆', number: 3, updatedAt: '2026-06-15' },
      { id: 'ch-6-4', title: '第4话：最后的客人', number: 4, updatedAt: '2026-07-15' },
    ],
    tags: ['治愈', '日常', '暖心', '都市'],
    updatedAt: '2026-07-15',
    createdAt: '2026-05-01',
  },
  {
    id: 'comic-7',
    title: '灵魂契约',
    author: '文智勋',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20mysterious%20Korean%20manhwa%20style%20illustration%20of%20a%20young%20man%20making%20a%20contract%20with%20a%20shadowy%20spirit%20entity%2C%20dark%20ritual%20atmosphere%2C%20glowing%20mystical%20symbols%2C%20supernatural%20thriller%20theme%2C%20dramatic%20contrast%20lighting%2C%20vertical%20portrait%20orientation&width=800&height=1100&seq=comic-cover-07&orientation=portrait',
    description: '为救病危的妹妹，少年与恶魔签订了灵魂契约。他获得了强大的力量，但每使用一次，就会失去一部分记忆。当记忆全部消失时，他的灵魂将归恶魔所有。',
    longDescription: '朴振宇的妹妹被诊断为罕见绝症，医生下了最后通牒——只剩下三个月的时间。走投无路的振宇偶然间翻到了祖父留下的一本古籍，书中记载了一个名为"灵魂契约"的禁忌仪式。\n\n在绝望中，他按照书中的指引完成了仪式。一个自称"路西法"的存在出现在他面前，提出了一个交易：振宇获得治愈一切疾病的能力，但每治愈一个人，他就会失去一段记忆。当所有记忆消失的那一刻，他的灵魂将永远属于恶魔。\n\n振宇毫不犹豫地签下了契约。妹妹的病奇迹般痊愈了。但他很快发现，自己开始忘记一些事情——起初是微不足道的小事，然后是朋友的名字、童年的回忆、甚至是家人的面孔。更可怕的是，路西法似乎在暗中操控着一切，让振宇不得不频繁使用能力……',
    categories: ['all', 'suspense', 'horror', 'drama'],
    status: '连载中',
    rating: 4.7,
    views: 1120000,
    favorites: 73000,
    chapters: [
      { id: 'ch-7-1', title: '第1话：最后的希望', number: 1, updatedAt: '2026-07-25' },
      { id: 'ch-7-2', title: '第2话：恶魔的交易', number: 2, updatedAt: '2026-07-27' },
      { id: 'ch-7-3', title: '第3话：被遗忘的名字', number: 3, updatedAt: '2026-07-29' },
      { id: 'ch-7-4', title: '第4话：契约的陷阱', number: 4, updatedAt: '2026-08-01' },
      { id: 'ch-7-5', title: '第5话：最后的记忆', number: 5, updatedAt: '2026-08-03' },
    ],
    tags: ['恶魔', '交易', '悬疑', '兄弟情'],
    updatedAt: '2026-08-03',
    createdAt: '2026-06-20',
  },
  {
    id: 'comic-8',
    title: '心跳补习班',
    author: '尹瑞妍',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20sweet%20Korean%20manhwa%20style%20illustration%20of%20a%20smart%20male%20student%20tutoring%20a%20cute%20female%20student%20in%20a%20classroom%20after%20school%2C%20golden%20sunset%20light%20through%20windows%2C%20cherry%20blossom%20petals%20outside%2C%20youthful%20romantic%20atmosphere%2C%20clean%20art%2C%20vertical%20portrait&width=800&height=1100&seq=comic-cover-08&orientation=portrait',
    description: '全校第一的学霸被迫给倒数第一的校花补习功课。本以为是一场灾难，没想到却成了两人最美好的高中回忆。',
    longDescription: '全校排名永远第一的学霸林志勋，因为班主任的"拜托"，不得不给全班倒数第一的校花宋彩英补习功课。彩英是学校里最受欢迎的女孩——漂亮、开朗、人缘好，但成绩差得令人发指。\n\n志勋原本以为这会是一场灾难。但彩英虽然学习差，却有着一颗无比真诚的心和让人无法拒绝的灿烂笑容。在每天的课后补习中，志勋发现这个看似无忧无虑的女孩，其实背负着父母离异、被寄养在奶奶家的沉重过往。\n\n而彩英也渐渐发现，志勋冷漠的外表下藏着一颗比谁都温暖的心。一段青涩而真挚的校园恋情，在每天的补习时光中悄悄萌芽……',
    categories: ['all', 'romance', 'comedy'],
    status: '已完结',
    rating: 4.8,
    views: 1950000,
    favorites: 108000,
    chapters: [
      { id: 'ch-8-1', title: '第1话：学霸与校花', number: 1, updatedAt: '2026-05-01' },
      { id: 'ch-8-2', title: '第2话：第一次补课', number: 2, updatedAt: '2026-05-08' },
      { id: 'ch-8-3', title: '第3话：秘密与眼泪', number: 3, updatedAt: '2026-05-15' },
      { id: 'ch-8-4', title: '第4话：樱花树下的约定', number: 4, updatedAt: '2026-06-01' },
      { id: 'ch-8-5', title: '第5话：毕业', number: 5, updatedAt: '2026-07-01' },
    ],
    tags: ['校园', '青春', '恋爱', '成长'],
    updatedAt: '2026-07-01',
    createdAt: '2026-04-15',
  },
  {
    id: 'comic-9',
    title: '幽灵事务所',
    author: '赵仁浩',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20supernatural%20Korean%20manhwa%20style%20illustration%20of%20a%20medium%20girl%20and%20a%20ghost%20detective%20partner%20working%20in%20a%20vintage%20office%20with%20floating%20documents%2C%20mysterious%20greenish%20glow%2C%20ghostly%20transparent%20figures%2C%20occult%20detective%20theme%2C%20vertical%20portrait&width=800&height=1100&seq=comic-cover-09&orientation=portrait',
    description: '能看见鬼魂的女大学生和去世多年的侦探鬼魂搭档，共同经营一家专门解决"灵异事件"的幽灵事务所。',
    longDescription: '沈夏琳天生拥有一双能看见鬼魂的眼睛。从小到大，她因为这个"特殊能力"吃尽了苦头——被当成怪胎，被同学排挤，连父母都觉得她精神有问题。\n\n大学二年级那年，夏琳搬进了一间因为"闹鬼"而租金极低的公寓。公寓里确实有一个鬼魂——一个在三十年前死于非命的私家侦探，金尚昊。尚昊告诉夏琳，他能"成佛"的唯一办法就是帮助那些含冤而死的灵魂了结心愿。\n\n于是，一家独特的"幽灵事务所"诞生了——夏琳负责与人沟通，尚昊负责调查和推理。他们接手的每一个案件都牵扯出一段不为人知的往事，每一个灵魂背后都有一个令人心碎的故事。随着调查越来越深入，夏琳开始怀疑：尚昊的死亡，真的只是一场意外吗？',
    categories: ['all', 'suspense', 'healing'],
    status: '连载中',
    rating: 4.6,
    views: 870000,
    favorites: 54000,
    chapters: [
      { id: 'ch-9-1', title: '第1话：闹鬼公寓', number: 1, updatedAt: '2026-07-20' },
      { id: 'ch-9-2', title: '第2话：第一个委托人', number: 2, updatedAt: '2026-07-22' },
      { id: 'ch-9-3', title: '第3话：30年前的真相', number: 3, updatedAt: '2026-07-25' },
    ],
    tags: ['灵异', '推理', '治愈', '搭档'],
    updatedAt: '2026-07-25',
    createdAt: '2026-06-05',
  },
  {
    id: 'comic-10',
    title: '武林至尊',
    author: '南成俊',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20martial%20arts%20Korean%20manhwa%20style%20illustration%20of%20a%20powerful%20warrior%20in%20traditional%20martial%20arts%20robe%20standing%20on%20a%20mountain%20peak%20with%20sword%2C%20dramatic%20wind%20and%20clouds%2C%20epic%20wuxia%20atmosphere%2C%20dynamic%20pose%2C%20ink%20wash%20painting%20style%2C%20vertical%20portrait&width=800&height=1100&seq=comic-cover-10&orientation=portrait',
    description: '废柴少年意外获得武林秘籍，从此踏上逆天改命之路。在这个弱肉强食的武林世界里，他将一步步登上至尊之位。',
    longDescription: '江淮安是青云派最低等的杂役弟子，每天的工作就是扫地、劈柴、挑水。他天生经脉堵塞，被认为这辈子都不可能练成任何武功。\n\n直到有一天，他不小心掉进了后山的禁地，在那里发现了一具枯骨和一本名为《天罡九转》的秘籍。枯骨的主人竟是一百年前名震武林的剑魔独孤问天——他因为走火入魔而死，临终前将毕生所学刻于秘籍之上。\n\n江淮安按照秘籍修炼，不仅打通了堵塞的经脉，更掌握了一门足以撼动整个武林的绝世武功。但江湖从来不缺乏野心家，当各大门派得知《天罡九转》的存在，一场席卷整个武林的腥风血雨就此展开……',
    categories: ['all', 'action', 'fantasy'],
    status: '连载中',
    rating: 4.5,
    views: 780000,
    favorites: 48000,
    chapters: [
      { id: 'ch-10-1', title: '第1话：杂役弟子', number: 1, updatedAt: '2026-07-18' },
      { id: 'ch-10-2', title: '第2话：禁地奇遇', number: 2, updatedAt: '2026-07-20' },
      { id: 'ch-10-3', title: '第3话：天罡九转', number: 3, updatedAt: '2026-07-22' },
      { id: 'ch-10-4', title: '第4话：初露锋芒', number: 4, updatedAt: '2026-07-25' },
    ],
    tags: ['武侠', '修炼', '逆袭', '热血'],
    updatedAt: '2026-07-25',
    createdAt: '2026-05-30',
  },
  {
    id: 'comic-11',
    title: '繁星街区的猫',
    author: '韩昭熙',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20charming%20Korean%20manhwa%20style%20illustration%20of%20a%20calico%20cat%20sitting%20on%20a%20windowsill%20in%20a%20cozy%20neighborhood%20under%20starry%20night%20sky%2C%20warm%20glowing%20windows%2C%20peaceful%20slice%20of%20life%20atmosphere%2C%20soft%20colors%2C%20vertical%20portrait&width=800&height=1100&seq=comic-cover-11&orientation=portrait',
    description: '以一只流浪猫的视角，讲述繁星街区居民们各自的人生故事。温暖、治愈，每一页都让人心头一软。',
    longDescription: '咪咪是繁星街区的一只三花猫，每天穿梭于大街小巷，用它的猫眼观察着人类世界的喜怒哀乐。\n\n独居老人金奶奶每天都会在门口放一碗猫粮，那是咪咪一天中最期待的时刻。金奶奶的儿女都在国外，她把咪咪当成了最亲近的家人。\n\n街头面包店的年轻师傅总是在凌晨四点开门，给自己和咪咪各准备一份早餐。他暗恋着对面花店的女孩，却从未敢表白。\n\n还有住在阁楼的漫画家、刚搬来的单亲妈妈、以及每个傍晚都会在天台拉小提琴的少年……每一个人的故事都通过咪咪的双眼被温柔地记录下来。在这个看似普通的街区里，每个人都在用自己的方式努力生活着，而咪咪就是连接他们的纽带。',
    categories: ['all', 'healing', 'drama'],
    status: '已完结',
    rating: 4.9,
    views: 1050000,
    favorites: 92000,
    chapters: [
      { id: 'ch-11-1', title: '第1话：咪咪的一天', number: 1, updatedAt: '2026-04-01' },
      { id: 'ch-11-2', title: '第2话：金奶奶的秘密', number: 2, updatedAt: '2026-04-15' },
      { id: 'ch-11-3', title: '第3话：面包与爱情', number: 3, updatedAt: '2026-05-01' },
      { id: 'ch-11-4', title: '第4话：星夜琴声', number: 4, updatedAt: '2026-05-15' },
      { id: 'ch-11-5', title: '最终话：繁星的祝福', number: 5, updatedAt: '2026-06-30' },
    ],
    tags: ['治愈', '动物', '日常', '温暖'],
    updatedAt: '2026-06-30',
    createdAt: '2026-03-15',
  },
  {
    id: 'comic-12',
    title: 'BL：同色系',
    author: '徐道允',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20BL%20Korean%20manhwa%20style%20illustration%20of%20two%20handsome%20young%20men%20standing%20close%20together%20in%20a%20university%20campus%20setting%2C%20cherry%20blossoms%20falling%2C%20tender%20romantic%20atmosphere%2C%20soft%20sunlight%2C%20elegant%20pastel%20colors%2C%20clean%20art%20style%2C%20vertical%20portrait&width=800&height=1100&seq=comic-cover-12&orientation=portrait',
    description: '美术学院的两个男生，一个偏爱暖色调，一个钟情冷色调。截然不同的两个人却在一次次创作碰撞中，画出了最美的渐变色。',
    longDescription: '学美术的郑在贤，作品以大胆的暖色调著称，为人外向热情，是美术系的焦点人物。\n\n同系的柳寒星，专攻冷色调水墨，性格内向寡言，总是一个人默默在画室的角落创作。\n\n两个看似毫无交集的人，因为一次校内展览的合作被分到了同一组。在贤对寒星的审美惊叹不已，而寒星则被在贤的热情和真诚慢慢融化。\n\n从最初的沉默对望，到笔触间的默契交流，再到深夜画室里不经意的触碰——两人的关系像一幅精心调配的渐变色，从两个极端慢慢交融，最终绘成了彼此生命中最美的色彩。',
    categories: ['all', 'bl', 'romance'],
    status: '连载中',
    rating: 4.7,
    views: 720000,
    favorites: 56000,
    chapters: [
      { id: 'ch-12-1', title: '第1话：暖色与冷色', number: 1, updatedAt: '2026-07-15' },
      { id: 'ch-12-2', title: '第2话：第一次合作', number: 2, updatedAt: '2026-07-18' },
      { id: 'ch-12-3', title: '第3话：深夜画室', number: 3, updatedAt: '2026-07-22' },
    ],
    tags: ['BL', '校园', '艺术家', '慢热'],
    updatedAt: '2026-07-22',
    createdAt: '2026-06-12',
  },
];

export const FAQ_DATA = [
  {
    question: '韩国漫画网上的所有韩漫都是免费的吗？',
    answer: '是的！韩国漫画网上的所有韩漫内容均为免费在线阅读。我们致力于为广大韩漫爱好者提供优质的免费阅读体验，无需任何付费即可畅享所有漫画内容。我们会持续更新最新的韩漫资源，确保您能够第一时间看到最新连载。',
  },
  {
    question: '网站上的韩漫更新频率是怎样的？',
    answer: '我们的内容团队每日更新韩漫资源，确保热门连载作品能够第一时间同步上线。通常热门漫画的更新周期为1-3天，部分作品会在韩网更新的同一天内完成中文版的同步上线。您可以关注首页的"最新更新"板块，随时掌握最新的更新动态。',
  },
  {
    question: '网站上的漫画有删减吗？',
    answer: '韩国漫画网坚持提供无删减、原汁原味的韩漫内容。我们深知韩漫读者对于作品完整性的重视，因此所有上线的漫画均保留原作的完整情节和画面，绝不进行任何形式的删减或修改，让您享受最纯粹的韩漫阅读体验。',
  },
  {
    question: '如何找到我想看的特定类型的韩漫？',
    answer: '您可以通过网站的分类导航功能轻松找到感兴趣的漫画类型。我们在导航栏和首页都设置了分类入口，涵盖恋爱、奇幻、动作、悬疑、搞笑、治愈、剧情、恐怖、BL等多种类型。点击任一分类即可查看该类型下的全部漫画作品。',
  },
  {
    question: '网站支持手机端阅读吗？',
    answer: '当然支持！韩国漫画网采用了响应式设计，完美适配手机、平板和电脑等多种设备。无论您使用什么设备访问，都能获得流畅舒适的阅读体验。在手机端，漫画的排版和字体大小都经过了专门优化，确保在小屏幕上也能轻松阅读。',
  },
  {
    question: '漫画加载慢怎么办？',
    answer: '漫画加载速度受多种因素影响，包括您的网络状况和当前访问人数。如果您遇到加载慢的情况，建议检查网络连接是否稳定，或者尝试刷新页面。我们也在持续优化服务器性能，以提供更快速的加载体验。如果问题持续存在，欢迎通过关于我们页面的联系方式向我们反馈。',
  },
];

export const REVIEWS = [
  { name: '小王', rating: 5, content: '这个网站真的太棒了！更新速度很快，画质也很清晰。以前到处找韩漫资源太累了，现在直接在这里看就够了。', date: '2026-07-28' },
  { name: '漫画迷阿琳', rating: 5, content: '分类做得很好，找漫画很方便。最重要的是真的无删减！之前在其他平台看的总觉得少了点什么，这里完全不会。强推！', date: '2026-07-25' },
  { name: '深夜读者', rating: 5, content: '深夜看韩漫的最佳选择。界面简洁干净没有乱七八糟的广告，阅读体验一级棒。已经推荐给身边所有喜欢韩漫的朋友了。', date: '2026-07-20' },
  { name: '韩漫爱好者小陈', rating: 5, content: '资源非常全，很多冷门的好作品都能在这里找到。而且页面设计看起来很舒服，不像有些网站那么杂乱。用了三个月了，每天必刷！', date: '2026-07-15' },
  { name: '莉莉安', rating: 4, content: '很喜欢这个网站的治愈类和恋爱类漫画，收藏了好多。希望以后能增加更多完结作品，连载追得太辛苦了哈哈。总之是非常良心的网站！', date: '2026-07-10' },
  { name: '追更达人', rating: 5, content: '更新速度没得说，基本韩网更新第二天这里就有了。翻译质量也很高，读起来很流畅。已经是我的韩漫阅读首选平台了！', date: '2026-07-05' },
];